module.exports = __webpack_public_path__ + "img/banner_es.2e8ed03c.jpg";